import React from 'react';
import PropTypes from 'prop-types';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { LayoutPaper } from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';
import useMobileLayout from 'Hooks/useMobileLayout';
import { FrequentlyAskedQuestionsContent } from './FrequentlyAskedQuestionsContent';

const useStyles = buildUseStyles('FrequentlyAskedQuestions', () => ({
  root: {
    width: '100%',
    flex: 1,
    flexBasis: 400, // This is not compatible with FD
  },
}));

export const FrequentlyAskedQuestions = ({ collection }) => {
  const isMobile = useMobileLayout();
  const classes = useStyles();

  if (collection.resources().length() === 0) {
    return null;
  }

  return (
    <div className={classes.root}>
      <FDContentContainer maxWidth={'md'}>
        <LayoutPaper padding={0}>
          <FDStack padding={isMobile ? 2 : 4}>
            <FrequentlyAskedQuestionsContent collection={collection} />
          </FDStack>
        </LayoutPaper>
      </FDContentContainer>
    </div>
  );
};

FrequentlyAskedQuestions.propTypes = {
  collection: PropTypes.object.isRequired,
};
